import { Download } from "lucide-react";

import { TableExportFormat } from "@/api/form";

import TableActionModal from "@/pages/form/final/table-action-modal";
import { tableExportOptions } from "@/pages/form/final/table-export-options";

interface TableExportModalProps {
  isOpen: boolean;
  isLoading: boolean;
  tableCount: number;
  onOpenChange: (open: boolean) => void;
  onSelect: (format: TableExportFormat) => void;
}

const TableExportModal: React.FC<TableExportModalProps> = ({
  isOpen,
  isLoading,
  tableCount,
  onOpenChange,
  onSelect
}) => {
  return (
    <TableActionModal
      isOpen={isOpen}
      isLoading={isLoading}
      tableCount={tableCount}
      onOpenChange={onOpenChange}
      onSelect={onSelect}
      title="انتخاب فرمت خروجی"
      description={`${tableCount} جدول برای خروجی آماده است. لطفا فرمت مورد نظر را انتخاب کنید.`}
      footerLabel="خروجی جدول"
      loadingText="در حال آماده سازی فایل خروجی..."
      options={tableExportOptions}
      headerIcon={Download}
    />
  );
};

export default TableExportModal;
